module.exports = __webpack_public_path__ + "static/media/Colizeum_4.5e1fbb5d.jpg";